import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import { AbstractModalComponent } from '../abstract-modal/abstract-modal.component';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-add-edit-department',
  templateUrl: './add-edit-department.component.pug',
  styleUrls: ['./add-edit-department.component.scss'],
  standalone: false
})
export class AddEditDepartmentComponent extends AbstractModalComponent implements OnInit, OnDestroy {
  @Input() model!: String;
  @Input() dept_data!: any;
  @Input() dept_list!: any;
  departmentName!: string;
  isValid = true;
  departmentCategory: any = {};
  departmentList: any;
  dropDownOptions: any = [];
  dropDownLabel = ''
  errorFeedback = false;
  inputSubject = new Subject<any>();

  errors = [
    { 'name': 'validName', 'msg': $localize`Department name is a required field.`, 'enabled': false },
    { 'name': 'sameName', 'msg': $localize`Department name must be unique.`, 'enabled': false },
  ];
  getForm() {
    throw new Error('Method not implemented.');
  }

  constructor(public _bsModalRef: BsModalRef,
    public organisationService: OrganisationService, public modal: WarningModalService, private alertList: AlertBannerService, public permissions:PermissionsService) { super(_bsModalRef, modal); }

  ngOnInit(): void {
    this.departmentName = this.dept_data.department;
    this.departmentList = this.dept_list;
    if (this.model == 'add') this.dropDownLabel = 'Select department category'
    else if (this.model == 'edit') {
      this.dropDownLabel = this.dept_data.category_name;
      this.departmentCategory['category_name'] = this.dept_data.category_name
      this.departmentCategory['id'] = this.dept_data.category_id;
    }
    this.getDepartments()
  }

  ngOnDestroy(): void {
    this.inputSubject.complete();
  }

  dropDownOptionSelected(department) {
    this.isValid = true;
    this.departmentCategory['category_name'] = department.value
    this.departmentCategory['id'] = department.key
    this.dept_data.category_id = department.key
    if (this.errors.findIndex(x => x.enabled == true) < 0 && this.departmentName && this.departmentName.trim().length > 0) {
      this.isValid = false
    }
  }


  closeModal() {
    this._bsModalRef.hide();
  }
  save() {
      this.organisationService.getDepartmentCheck(this.departmentName.trim()).subscribe(
        (data) => {
          this.handleDataExistence(data)

          if (this.errors.findIndex(x => x.enabled == true) < 0) {
            if (Object.keys(this.departmentCategory).length > 0) this.isValid = false
          }
        }),
        (error) => {
          console.log(error)
          this.isValid = false
        }
  }
  getDepartments() {
    this.organisationService.getDepartmentCategories().subscribe((res) => {
      if (res) {
        let i = 0;
        res.data.categories.forEach(r => {
          i += 1;
          this.dropDownOptions.push({
            "key": r.id.toString(),
            "value": r.name
          })
        })
      }
    },
      (error) => {
        console.log(error)
      })
  }

  checkDepartment(dept) :void{
    this.resetErrors()
    if (!this.containsOnlySpaces(dept) && dept.length > 0 && Object.keys(this.departmentCategory).length != 0) {
      this.isValid = false
    }
  }

  checkLocalDepartmentExistance(dept){
    const exists = this.departmentList.some(element => {
      return element.department.trim().toLowerCase() === dept.trim().toLowerCase()
    })
    return exists
  }

  debounceCheckDepartment(dept) {
    this.resetErrors()
    if(dept){
      this.organisationService.getDepartmentCheck(dept.trim()).subscribe(
        (data) => {
          if (data.data.exists || this.checkLocalDepartmentExistance(dept)) this.setError('sameName', true)
          else {
            this.resetErrors()
          }
          if (this.errors.findIndex(x => x.enabled == true) < 0) {
            if (Object.keys(this.departmentCategory).length > 0) this.isValid = false
          }
        }),
        (error) => {
          console.log(error)
          this.isValid = false
        }
    }
    else {
      this.isValid = true;
      this.setError('validName', true)
    }
  }
  resetErrors(){
    this.isValid = true;
    this.errors.forEach(x => x.enabled = false)
  }
  setError(name: string, enabled: boolean) {
    this.errors.find(o => o.name === name)!.enabled = enabled;
    this.errors = [...this.errors];
  }

  containsOnlySpaces(text:string) {
    return text.trim() === '';
  }

  handleDataExistence(data) {
    if (data.data.exists) {
      this.setError('sameName', true);
      this.isValid = true;
    } else {
      this.resetErrors();
      let dataToSend = {
        'model': '',
        'department': this.departmentName,
        "category_name": this.departmentCategory.category_name,
        "id": ''
      };
      if (this.model == 'add') {
        this._bsModalRef.hide();
        dataToSend.model = 'add';
        dataToSend.id = this.departmentCategory.id;
      }
      if (this.model == 'edit') {
        this._bsModalRef.hide();
        dataToSend.model = 'edit';
        dataToSend.id = this.dept_data.id;
        dataToSend['category_id'] = this.dept_data.category_id;
      }
      this.event.emit(dataToSend);
    }
  }


}
